import { watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

/**
 * 用于管理SEO标签的组合式函数
 * 动态更新canonical和hreflang标签
 */
export function useSeoTags() {
  const route = useRoute();
  const { locale } = useI18n();
  
  // 基础URL
  const baseUrl = 'https://whisperherb.com';
  
  // 支持的语言列表
  const supportedLocales = ['en', 'zh', 'fr', 'de', 'nl', 'es'];
  
  /**
   * 更新canonical和hreflang标签
   */
  const updateSeoTags = () => {
    // 获取当前路径（不包含查询参数）
    const path = route.path;
    
    // 更新canonical标签
    const canonicalLink = document.getElementById('canonical-link');
    if (canonicalLink) {
      // 如果当前语言不是英语，canonical应该指向英语版本
      if (locale.value === 'en') {
        canonicalLink.setAttribute('href', `${baseUrl}${path}`);
      } else {
        canonicalLink.setAttribute('href', `${baseUrl}${path}`);
      }
    }
    
    // 移除现有的hreflang标签
    const existingHreflangs = document.querySelectorAll('link[rel="alternate"][hreflang]');
    existingHreflangs.forEach(tag => {
      if (tag.hasAttribute('data-dynamic')) {
        tag.remove();
      }
    });
    
    // 为每种支持的语言添加hreflang标签
    supportedLocales.forEach(lang => {
      const hreflangLink = document.createElement('link');
      hreflangLink.rel = 'alternate';
      hreflangLink.hreflang = lang;
      
      // 设置URL（带有语言参数，除了默认语言）
      if (lang === 'en') {
        hreflangLink.href = `${baseUrl}${path}`;
      } else {
        hreflangLink.href = `${baseUrl}${path}?lang=${lang}`;
      }
      
      hreflangLink.setAttribute('data-dynamic', 'true');
      document.head.appendChild(hreflangLink);
    });
    
    // 添加x-default hreflang标签
    const defaultLink = document.createElement('link');
    defaultLink.rel = 'alternate';
    defaultLink.hreflang = 'x-default';
    defaultLink.href = `${baseUrl}${path}`;
    defaultLink.setAttribute('data-dynamic', 'true');
    document.head.appendChild(defaultLink);
  };
  
  // 监听路由和语言变化
  watch(
    () => [route.path, locale.value],
    () => {
      updateSeoTags();
    }
  );
  
  // 组件挂载时更新标签
  onMounted(() => {
    updateSeoTags();
  });
  
  return {
    updateSeoTags
  };
}